module.exports = __webpack_public_path__ + "img/labor.defadfcb.png";